class AddToCartPopup extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }
    
    init() {
        console.log( '[Add To Cart Popup] Init' );
        this.cart = null;
        this.initCartItems();
        this.attachEvents();
        this.focusFirstElementOnLoad();
    }

    initCartItems( ) {
        try {
            const itemsScript = this.querySelector('#cart-items');
            if ( itemsScript != null ) {
                this.cart = JSON.parse( itemsScript.innerHTML );
            }
        } catch ( error ) {
            console.error( error );
        }

        return;
    }

    attachEvents() {
        document.addEventListener( 'click' , this.handleOutsideModalClick.bind( this ) );
        document.addEventListener( 'keydown' , this.handleEscapeKeyPress.bind( this ) );

        const closePopupButtons = this.querySelectorAll('.dismiss-popup');
        for ( let i = 0; i < closePopupButtons.length; i++ ) {
            closePopupButtons[i].addEventListener( 'click' , this.handleCloseModal.bind( this ) );
        }

        const switchToDeliveryButtons = this.querySelectorAll('.switch-to-delivery-btn');
        for ( let i = 0; i < switchToDeliveryButtons.length; i++ ) {
            switchToDeliveryButtons[i].addEventListener( 'click' , this.swapDeliveryTypes.bind( this ) );
        }

        const inputs = this.querySelectorAll( '.quantity-selector-value' );
        this.debouncedQtyInputChange = this.debounce( this.handleQtyInputChange.bind(this), 1000 );
        for ( let i = 0; i < inputs.length; i++ ) {
            inputs[i].addEventListener( 'change' , this.debouncedQtyInputChange );
            inputs[i].addEventListener( 'keydown', this.preventNonNumericInput );
            inputs[i].addEventListener( 'paste', this.preventInvalidPaste );
        }
    }

    focusFirstElementOnLoad() {
        const focusableSelector = '.dismiss-popup';
        const firstFocusable = this.querySelector( focusableSelector );
        if ( firstFocusable != null ) {
            firstFocusable.focus();
        }
    }

    focusTriggerEl() {
        const triggerEl = document.querySelector( '.product-form__add-button' );
        if ( triggerEl != null ) {
            triggerEl.focus();
        }
    }

    handleCloseModal( e ) {
        this.remove();
        this.focusTriggerEl();

        return;
    }

    handleEscapeKeyPress( e ) {
        if ( e.key === 'Escape' ) {
            this.remove();
            this.focusTriggerEl();
        }
    }

    handleOutsideModalClick( e ) {
        const elementClicked = e.target;
        const modal = this;
        const isClickInside = modal.contains( elementClicked );

        if ( !isClickInside ) {
            modal.remove();
        }
    }

    debounce( func, delay ) {
        let timer;
        return function ( ...args ) {
            clearTimeout( timer );
            timer = setTimeout( () => func.apply(this, args), delay );
        };
    }

    preventNonNumericInput(e) {
        const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
        const isCtrlCmd = e.ctrlKey || e.metaKey;
    
        if (
            allowedKeys.includes(e.key) ||
            (isCtrlCmd && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase()))
        ) return;
    
        if (!/^\d$/.test(e.key)) {
            e.preventDefault();
        }
    }
    
    preventInvalidPaste(e) {
        const paste = e.clipboardData.getData('text');
        if (!/^\d+$/.test(paste)) {
            e.preventDefault();
        }
    }

    async handleQtyInputChange( e ) {
        const inputChanged = e.target;
        const rawValue = inputChanged.value;
        const itemKey = inputChanged.getAttribute('data-item-key');
        const originalValue = inputChanged.getAttribute( 'data-current-value' );

        let newValue = parseInt( rawValue );
        if ( isNaN( newValue ) || newValue < 0 ) {
            inputChanged.value = originalValue;
            return;
        }

        const updates = {};
        updates[ itemKey ] = newValue;
        const finishedUpdates = await this.updateItems();
        if ( !finishedUpdates ) {
            console.warn( '[Add To Cart Popup] Failed to update item! Exiting...' );
            return;
        }

        await this.reload();
    }

    async updateItems( updates ) {
        let finished = false;
        
        try {
            const requestSettings =  {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify( { updates } )
            };
            const response = await fetch( window.Shopify.routes.root + 'cart/update.js', requestSettings );
            if ( response.ok ) {
                finished = true;
            }
        } catch ( error ) {
            console.error( error );
        }

        return finished;
    }

    async swapDeliveryTypes( e ) {
        const itemsToReadd = { items: [] };
        const updates = {};
        
        for ( let i = 0; i < this?.cart?.items?.length; i++ ) {
            const item = this.cart.items[i];
            if ( item.is_curbside_item ) {
                updates[ item.key ] = 0;
                itemsToReadd.items.push({
                    id: item.id,
                    quantity: item.quantity
                });
            }
        }

        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        const finishedRemoving = await this.removeItems( updates );
        if ( !finishedRemoving ) {
            console.warn( '[Add To Cart Popup] Failed to remove all curbside items! Exiting...' );
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            return;
        }

        const finishedAdding = await this.addItems( itemsToReadd );
        if ( !finishedAdding ) {
            console.warn( '[Add To Cart Popup] Failed to add all curbside items! Exiting...' );
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            return;
        }

        await this.reload();
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }

    async removeItems( updates ) {
        let finished = false;
        
        try {
            const requestSettings =  {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify( { updates } )
            };
            const response = await fetch( window.Shopify.routes.root + 'cart/update.js', requestSettings );
            if ( response.ok ) {
                finished = true;
            }
        } catch ( error ) {
            console.error( error );
        }

        return finished;
    }

    async addItems( itemsObject ) {
        let finished = false;
        
        try {
            const requestSettings =  {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify( itemsObject )
            };

            const response = await fetch( window.Shopify.routes.root + 'cart/add.js', requestSettings );
            if ( response.ok ) {
                finished = true;
            }
        } catch ( error ) {
            console.error( error );
        }

        return finished;
    }

    async reload() {
        try {
            const response = await fetch( window.location.pathname + "?sections=add-to-cart-popup" );
            const data = await response.json();
            const sectionHTMLText = data['add-to-cart-popup'];
            const el = document.createElement('div');
            el.innerHTML = sectionHTMLText;
            const trueEL = el.querySelector( 'cart-popup' );
            if ( trueEL != null ) {
                const appendPoint = document.querySelector( '.cart-popup-append-point' );
                if ( appendPoint != null ) {
                    const cartPopupEl = document.querySelector( 'cart-popup' );
                    if ( cartPopupEl != null ) {
                        cartPopupEl.replaceWith( trueEL );
                        cartPopupEl.init();
                    } else {
                        appendPoint.append( trueEL ); 
                    }
                }
            }
        } catch ( error ) {
            console.error( error );
            console.log( '[Add To Cart Popup] Failed to inject cart popup into page.' );
        }

        return;
    }
}

customElements.define( 'cart-popup', AddToCartPopup );